import { Form, Modal, notification, Row, Button } from "antd";
import { BusinessRole } from "shared/interfaces";
import React from "react";
import getAPI from "../../services/api";
import TextArea from "antd/es/input/TextArea";

const SignatureModal: React.FC<{
  shiftId: number | undefined;
  signType: BusinessRole;
  open: boolean;
  readonly: boolean;
  onSign: () => void;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ shiftId, signType, open, readonly, onSign, setOpen }) => {
  const [form] = Form.useForm();

  const submit = async (values: any) => {
    try {
      const api = await getAPI();

      await api.put(`/shifts/${shiftId}/sign${signType}`, { data: { comment: values.comment } });

      notification.success({
        message: "Success",
        description: "The shift was successfully signed",
      });
      await onSign();
      setOpen(false);
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: `${error.message}`,
      });
    }
  };

  const customFooter = () =>
    !readonly && (
      <Row justify="end">
        <Button key="cancel" onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button key="submit" type="primary" onClick={() => form.submit()}>
          Sign
        </Button>
      </Row>
    );

  return (
    <>
      {shiftId && (
        <Modal
          title={`Sign shift (${signType})`}
          open={open}
          onOk={async () => {
            await form.submit();
            setOpen(false);
          }}
          onCancel={() => {
            setOpen(false);
          }}
          maskClosable={false}
          destroyOnClose
          width={600}
          footer={customFooter()}
        >
          <Row justify="center">
            <Form
              form={form}
              name="basic"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
              style={{ width: "100%" }}
              onFinish={submit}
              autoComplete="off"
              disabled={readonly}
            >
              <Form.Item label="Comment" name="comment" initialValue={""}>
                <TextArea rows={6} />
              </Form.Item>
            </Form>
          </Row>
        </Modal>
      )}
    </>
  );
};

export default SignatureModal;
